import React, { type ComponentProps } from 'react';

import { createContainer, type OverrideContainerComponent } from 'react-sweet-state';

import { fg } from '@atlaskit/platform-feature-flags/fg';
import type { ChatStorePrivateState } from '@atlassian/conversation-assistant-store/controllers/chat/types';

import type { ChatStoreActions } from './actions';
import { chatStore } from './chatStore';
import { ChatStoreInitializer } from './ChatStoreInitializer';
import { initializeChatStore } from './initializeChatStore';
import type { ChatStoreAction, ChatStoreContainerProps } from './types';
import { updateChatStoreSite } from './updateChatStoreSite';

const SweetStateChatStoreContainer = createContainer<
	ChatStorePrivateState,
	ChatStoreActions,
	ChatStoreContainerProps
>(chatStore, {
	onInit: (): ChatStoreAction => (api, props) => {
		if (!fg('rovo_chat_initialize_after_commit')) {
			return initializeChatStore()(api, props);
		}
	},
	onUpdate: (): ChatStoreAction => (api, props) => {
		if (!fg('rovo_chat_initialize_after_commit')) {
			return updateChatStoreSite()(api, props);
		}
	},
});

export const ChatStoreContainer: OverrideContainerComponent<ChatStoreContainerProps> =
	Object.assign(
		function ChatStoreContainer(props: ComponentProps<typeof SweetStateChatStoreContainer>) {
			const content = (
				<SweetStateChatStoreContainer {...props}>
					{fg('rovo_chat_initialize_after_commit') && (
						<ChatStoreInitializer siteId={props.siteId} />
					)}
					{props.children}
				</SweetStateChatStoreContainer>
			);
			return content;
		},
		{ override: true as const },
	);
